export const cleanHTML = (str) => {
  if (str) {
    return `${str}`
      .replace(/\\'/g, "'") // replace escaped single quote
      .replace(/\\"/g, '"') // replace escaped double quote
  }

  return ''
}
